import React from "react";

interface SettingItemProps {
  title: string;
  subtitle?: string;
  style?:string;
  noborder?:boolean;
  action: any;
}

const SettingItem: React.FC<SettingItemProps> = ({
  action,
  title, 
  style,
  noborder,
  subtitle = undefined,
}) => {
  return (
    <div
      className={`  ${
        (!subtitle && !noborder) ? "border border-gray-300 " : ""
}  px-4  rounded-[8px]  flex justify-between items-center w-full   `}
    >
      <div className=" flex flex-col font-semibold text-sm text-textbg">
        <p>{title}</p>
        <p className="text-xs mt-2 font-medium">{subtitle}</p>
      </div>{" "}
      {action}
    </div>
  );
};

export { SettingItem };
